import request from '@/utlis/request'
// 查询所有角色
export function GetRoleList(params) {
    return request({
        url: '/admin/role/findrole',
        method: 'get',
        params
    })
}
// 添加角色
export function AddRole(data) {
    return request({
        url: '/admin/role/addrole',
        method: 'post',
        data
    })
}
// 更新角色
export function updateRole(data) {
    return request({
        url: '/admin/role/updaterole',
        method: 'post',
        data
    })
}

// 删除角色
export function DeleteRole(data) {
    return request({
        url: '/admin/role/deleterole',
        method: 'post',
        data
    })
}

// 查询所有菜单
export function GetMenu() {
    return request({
        url: '/admin/sysmenu/findsysmenu',
        method: 'get',
    })
}
// 根据用户 ID 查询绑定菜单
export function GetIDMenu(params) {
    return request({
        url: '/admin/roleSysMenu/findRoleSysMenu',
        method: 'get',
        params
    })
}
// 根据用户 ID 添加、删除、修改绑定菜单
export function IdAddMenu(data) {
    return request({
        url: '/admin/roleSysMenu/updateRoleSysMenu',
        method: 'post',
        data
    })
}
// 添加菜单
export function addsysmenu(data) {
    return request({
        url: '/admin/sysmenu/addsysmenu',
        method: 'post',
        data
    })
}
// 根据ID删除菜单
export function delsysmenu(data) {
    return request({
        url: '/admin/sysmenu/deletesysmenu',
        method: 'post',
        data
    })
}
// 更新菜单
export function Updatesysmenu(data) {
    return request({
        url: '/admin/sysmenu/updatesysmenu',
        method: 'post',
        data
    })
}
// 查询所有用户
export function GetAllUser(data) {
    return request({
        url: '/admin/sysuser/findSysUsersPage',
        method: 'post',
        data
    })
}
// 注册用户
export function registerUser(data) {
    return request({
        url: '/admin/sysuser/auth/register',
        method: 'post',
        data
    })
}
// 用户添加角色
export function addRoleuser(data) {
    return request({
        url: '/admin/roleuser/addroleuser',
        method: 'post',
        data
    })
}
// 用户更新角色
export function UpdateRoleuser(data) {
    return request({
        url: '/admin/roleuser/updateroleuser',
        method: 'post',
        data
    })
}
// 查询用户所有角色
export function GetUserRole(params) {
    return request({
        url: '/admin/roleuser/findroleuser',
        method: 'get',
        params
    })
}
// 查询所有权限
export function findrule(params) {
    return request({
        url: '/admin/rule/findrule',
        method: 'get',
        params
    })
}
// 添加权限
export function addrule(data) {
    return request({
        url: '/admin/rule/addrule',
        method: 'post',
        data
    })
}
// 更新权限
export function updateAurule(data) {
    return request({
        url: '/admin/rule/updaterule',
        method: 'post',
        data
    })
}
// 删除权限
export function delrule(data) {
    return request({
        url: '/admin/rule/deleterule',
        method: 'post',
        data
    })
}
// 用户更新权限
export function updaterule(data) {
    return request({
        url: '/admin/ruleuser/updateruleUser',
        method: 'post',
        data
    })
}
// 查询用户所有权限
export function FindruleUser(params) {
    return request({
        url: '/admin/ruleuser/findruleUser',
        method: 'get',
        params
    })
}